// action
import {
    DELETE_SAMPLE_CONTAINER_TEST_MAP,
    DELETE_SAMPLE_CONTAINER_TEST_MAP_FAIL,
    DELETE_SAMPLE_CONTAINER_TEST_MAP_SUCCESS,
    DELETE_SAMPLE_CONTAINER_TEST_MAP_RESET
} from '../action/deleteSampleContainerTestMapAction'
import { api_err_msg } from "../strings.json"

// initialState
const initialState = {
    apiState: "",
    message: ""
}

export default function (state = initialState, action) {
    switch (action.type) {
        case DELETE_SAMPLE_CONTAINER_TEST_MAP:
            return {
                ...state,
                apiState: "loading"
            }
        case DELETE_SAMPLE_CONTAINER_TEST_MAP_FAIL:
            return {
                ...state,
                apiState: "error",
                message: action.response && action.response.data && action.response.data.message || api_err_msg,
            }
        case DELETE_SAMPLE_CONTAINER_TEST_MAP_SUCCESS:
            return {
                ...state,
                apiState: "success",
                message: action.response.data.message,
            }
        case DELETE_SAMPLE_CONTAINER_TEST_MAP_RESET:
            return initialState
        default:
            return state
    }
}